// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import styled, { type StyledComponent } from 'styled-components'
import postJson from '../../services/postJson'
import ErrorText from '../controls/ErrorText'
import AutoSizeTextArea from '../AutoSizeTextArea'
import Button from '../controls/PrimaryButton'

const FormWrapper: StyledComponent<Object, any, any> = styled.div`
  width: 460px;
`
const InputGroup: StyledComponent<Object, any, any> = styled.div`
  font-size: 14px;
  padding-bottom: 12px;
`
const TextInput: StyledComponent<Object, any, any> = styled.input`
  width: 100%
  max-width: 460px;
`
const RulesDescription: StyledComponent<Object, any, any> = styled.div`
  font-size: 14px;
  line-height: 18px;
  padding-bottom: 12px;
`
const RulesBlock: StyledComponent<Object, any, any> = styled.div`
  &:before {
    content: ' ';
    display: table;
  }
  &:after {
    content: ' ';
    display: table;
    clear: both;
  }
`
const StyledAutoSizeTextArea: typeof AutoSizeTextArea = styled(AutoSizeTextArea)`
  font-size: 14px;
  color: #000;
  resize: none;
  width: 100%
  max-width: 460px;
`
const ExamplesWrapper: StyledComponent<Object, any, any> = styled.div`
  margin-right: 20px;
  font-family: 'PT Sans Caption', sans-serif;
  font-size: 11px;
  color: #000;
  line-height: 16px;
`
const ExampleUrls: StyledComponent<Object, any, any> = styled.div`
  margin: 0 0 10px;
`
const ExampleUrl: StyledComponent<Object, any, any> = styled.div`
  color: #229dcb;
  text-decoration: underline dotted;
  &:hover {
    color: $alert-color;
  }
`

type Errors = Array<string>

type Props = {|
  onClose: Function,
  onObjectCreated: Function
|}

type State = {|
  isLoading: boolean,
  name: string,
  nameErrors: Errors,
  siteUrl: string,
  siteUrlErrors: Errors,
  substrings: string,
  substringsErrors: Errors
|}

const t = {
  label: 'Создать сегмент для ретаргетинга',
  create: 'Создать сегмент',
  name: 'Название для сегмента',
  site_url: 'Домен',
  rules_description:
    'Укажите вхождения в URL, при посещении которых посетитель будет записываться в аудиторию. Каждое вхождение с новой строки',
  example_description: 'Например вы можете указать:'
}

const CREATE_SEGMENT_URL = '/api/v1/segments'
const EXAMPLE_URLS = [
  '/',
  '/bonus30',
  ' /catalog/woman/dresses/',
  '/catalog/woman/jeans/',
  '/catalog/woman/shoes/'
]

export default class SegmentForm extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      isLoading: false,
      name: '',
      nameErrors: [],
      siteUrl: '',
      siteUrlErrors: [],
      substrings: '',
      substringsErrors: []
    }
  }

  render() {
    return (
      <FormWrapper>
        <h2>{t.label}</h2>
        <InputGroup>
          <TextInput
            className="input-item"
            name="segment_name"
            disabled={this.state.isLoading}
            placeholder={t.name}
            value={this.state.name}
            onChange={(e) => this.setState({ name: e.target.value })}
          />
          <ErrorText errors={this.state.nameErrors} />
        </InputGroup>
        <InputGroup>
          <TextInput
            className="input-item"
            name="segment_site_url"
            disabled={this.state.isLoading}
            placeholder={t.site_url}
            value={this.state.siteUrl}
            onChange={(e) => this.setState({ siteUrl: e.target.value })}
          />
          <ErrorText errors={this.state.siteUrlErrors} />
        </InputGroup>
        <RulesDescription>{t.rules_description}</RulesDescription>
        <RulesBlock>
          <StyledAutoSizeTextArea
            minRows={5}
            maxRows={5}
            className="input-item"
            name="segment_substrings"
            value={this.state.substrings}
            onChange={(e) => this.setState({ substrings: e.target.value })}
            disabled={this.state.isLoading}
          />
          <ErrorText errors={this.state.substringsErrors} />
          <ExamplesWrapper>
            <ExampleUrls>
              {t.example_description}
              {_.map(EXAMPLE_URLS, (url, index: number) => {
                return <ExampleUrl key={index}>{url}</ExampleUrl>
              })}
            </ExampleUrls>
          </ExamplesWrapper>
        </RulesBlock>
        <Button onClick={() => this.createSegment()}>{t.create}</Button>
      </FormWrapper>
    )
  }

  createSegment() {
    this.setState({ isLoading: true })
    const data = {
      name: this.state.name,
      site_url: this.state.siteUrl,
      substrings: this.state.substrings
    }
    postJson(CREATE_SEGMENT_URL, { segment: data })
      .done((response) => {
        this.props.onClose()
        this.props.onObjectCreated(response.data)
      })
      .fail(({ responseJSON }: any) => {
        this.setState({
          nameErrors: responseJSON.message.name || [],
          siteUrlErrors: responseJSON.message.site_url || [],
          substringsErrors: responseJSON.message.substrings || []
        })
      })
      .always(() => this.setState({ isLoading: false }))
  }
}
